import { openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createBlock("input", {
    type: "text",
    class: "text-right form-input",
    ref: "input",
    value: _ctx.formattedValue(_ctx.modelValue),
    onBlur: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.onBlur($event.target.value);
    }),
    onFocus: _cache[2] || (_cache[2] = function () {
      return _ctx.onFocus && _ctx.onFocus.apply(_ctx, arguments);
    })
  }, null, 40, ["value"]);
}